import { useState } from "react";
import { Avatar, CircularProgress } from "@mui/material";
import userProfile from "assets/images/user-profile.png"; // fallback image

const AvatarWithLoader = ({
  src,
  alt,
  width,
  height,
  variant = "circular",
  leftMargin = false,
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const handleImageError = () => {
    setImageError(true);
  };

  // Check if avatar src is provided and not empty
  const hasValidAvatar = src && src.trim() !== "";

  return (
    <Avatar
      sx={{
        width: width || 40,
        height: height || 40,
        mr: leftMargin ? 0 : 2,
        ml: leftMargin ? 2 : 0,
        position: "relative", // Ensuring loader is on top of Avatar
      }}
      variant={variant}
    >
      {!hasValidAvatar ? (
        // If no avatar, fallback to a default image without a loader
        <img
          src={userProfile}
          alt={alt}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      ) : (
        <>
          {!imageLoaded && !imageError && (
            <CircularProgress
              size={24}
              sx={{
                position: "absolute",
              }}
            />
          )}
          {imageError ? (
            <img
              src={userProfile} // fallback image on error
              alt={alt}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          ) : (
            <img
              src={src}
              alt={alt}
              onLoad={handleImageLoad}
              onError={handleImageError}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          )}
        </>
      )}
    </Avatar>
  );
};

export default AvatarWithLoader;
